import { AppState } from 'src/app/store'

export const saleOffersSelector = (state: AppState) => state.saleOffers
export const allSaleOffersSelector = (state: AppState) => state.saleOffers.allSaleOffers
export const saleOffferFilterProjectSelector = (state: AppState) => state.saleOffers.filterProject
export const userSaleOffersSelector = (state: AppState) => state.saleOffers.userSaleOffers
export const saleOffferDetailsSelector = (state: AppState) => state.saleOffers.saleOfferDetails
export const acceptSaleOffferSelector = (state: AppState) => state.saleOffers.acceptOffer
export const rejectSaleOffferSelector = (state: AppState) => state.saleOffers.rejectOffer
export const counterSaleOffferSelector = (state: AppState) => state.saleOffers.makeCounterOffer

export const isOffersLoading = (state: AppState): boolean => {
  return  (
    state.saleOffers.userSaleOffers.loading ||
    state.offers.offers.loading
  )
}
